import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function InventoryIcon(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M15.5 19.5691L11.5961 15.6652L12.65 14.6114L15.5 17.4614L21.1692 11.7922L22.223 12.846L15.5 19.5691ZM20.5 9.99987H19V5.30759C19 5.23066 18.9679 5.16013 18.9038 5.09602C18.8397 5.03192 18.7692 4.99987 18.6922 4.99987H16.5V7.61522H7.5V4.99987H5.3077C5.23077 4.99987 5.16024 5.03192 5.09612 5.09602C5.03202 5.16013 4.99997 5.23066 4.99997 5.30759V18.6921C4.99997 18.7691 5.03202 18.8396 5.09612 18.9037C5.16024 18.9678 5.23077 18.9999 5.3077 18.9999H11V20.4998H5.3077C4.80898 20.4998 4.38302 20.3232 4.02982 19.97C3.67661 19.6168 3.5 19.1909 3.5 18.6921V5.30759C3.5 4.80888 3.67661 4.38292 4.02982 4.02972C4.38302 3.6765 4.80898 3.49989 5.3077 3.49989H9.71348C9.85194 3.01272 10.135 2.60889 10.5625 2.28839C10.99 1.96788 11.4692 1.80762 12 1.80762C12.5512 1.80762 13.0381 1.96788 13.4605 2.28839C13.883 2.60889 14.1634 3.01272 14.3019 3.49989H18.6922C19.191 3.49989 19.6169 3.6765 19.9701 4.02972C20.3233 4.38292 20.5 4.80888 20.5 5.30759V9.99987ZM12 5.11527C12.2577 5.11527 12.4727 5.02905 12.6452 4.85662C12.8176 4.68418 12.9038 4.46912 12.9038 4.21142C12.9038 3.95373 12.8176 3.73868 12.6452 3.56624C12.4727 3.39381 12.2577 3.30759 12 3.30759C11.7423 3.30759 11.5272 3.39381 11.3548 3.56624C11.1823 3.73868 11.0961 3.95373 11.0961 4.21142C11.0961 4.46912 11.1823 4.68418 11.3548 4.85662C11.5272 5.02905 11.7423 5.11527 12 5.11527Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}